<template>
  <div class="artist-list">
    <div class="artist-list-header">
      <span>Top <strong>level {{ getLevel(level) }}</strong> artists</span>
      <div class="icons">
        <div
          class="icon"
          :class="{'is-active': filter == 'author'}"
          @click="changeFilter('author')"
        >
          <i class="mdi mdi-pencil" />
        </div>
        <div
          class="icon"
          :class="{'is-active': filter == 'composer'}"
          @click="changeFilter('composer')"
        >
          <i class="mdi mdi-music" />
        </div>
        <div
          class="icon"
          :class="{'is-active': filter == 'interpret'}"
          @click="changeFilter('interpret')"
        >
          <i class="mdi mdi-microphone" />
        </div>
      </div>
    </div>
    <div class="artist-list-wrapper">
      <div class="artist-list-content">
        <div
          v-for="item in filteredData"
          :key="item.id"
          class="artist-list-item"
          :class="{'is-main': item.artist.id == artistId}"
          @click="toArtist(item.artist)"
          @mouseover="$emit('mouseoverartist', {id: item.artist.id, level: level})"
          @mouseleave="$emit('mouseoverartist', {id:null, level:null})"
        >
          <div class="data">
            <div class="name">
              {{ item.artist.name }}
            </div>
            <div class="info">
              {{ item[level].total }} implications
            </div>
          </div>
          <div class="graphs">
            <div
              v-for="role in ['author', 'composer', 'interpret']"
              :key="role"
              class="graph"
              :class="`graph-${role}`"
            >
              <div
                v-for="i in 10"
                :key="i"
                class="graph-line"
                :class="{'is-active': Math.ceil(10*(item[level][role]/item[level].total)*(item[level].total/max)) > (10-i)}" 
                @mouseover="$emit('mouseoverrole', role)"
                @mouseleave="$emit('mouseoverrole', null)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { toArtist } from "@/services/navigator";

export default {
	props: {
		data: {
			type: Array,
			required: true
		},
		level: {
			type: String,
			required: true
		},
		artistId: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			filter: null
		};
	},  
	computed: {
		max () {
			return this.data[0][this.level].total;
		},
		filteredData () {
			return this.data.filter(item => {
				if (this.filter == null) {
					return true;
				}
				return item[this.level][this.filter] > 0;
			}).sort((a,b) => b[this.level][this.filter] - a[this.level][this.filter]);
		}
	},
	methods: {
		getLevel (level) {
			if (level == "source") return "-1";
			if (level == "own") return "0";
			if (level == "target") return "+1";
		},
		toArtist (artist) {
			toArtist(artist.id);
		},
		changeFilter (filter) {
			if (this.filter == filter) {
				this.filter = null;
			} else {
				this.filter = filter;
			}
		}
	}
};
</script>

<style lang="scss" scoped>

$headerHeight: 35px;
$itemHeight: 40px;
$graphHeight: 30px;
$graphSpacing: 1px;
$mainItemHeight: 60px;

.artist-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-right: 1px solid #f1f1f1;
}

.artist-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: $headerHeight;
    box-shadow: 1px 1px 3px rgba(0,0,0,0.1);
    z-index: 2;
    position: relative;
    padding-left: 0.7rem;
    padding-right: 20px;
    font-size: 0.9rem;

    .icon {
        width: 1.42rem;
        cursor: pointer;
        color: #999999;

        &:hover {
            color: #666666;
        }

        &.is-active {
            color: #333;

            &:hover {
                color: #000;
            }
        }
    }
}

.artist-list-content {
    height: $itemHeight * 7 - 1;
    overflow-y: scroll;
}

.artist-list-item {
    display: flex;
    justify-content: space-between;
    line-height: 1.2;
    height: $itemHeight;
    align-items: center;
    padding-left: 0.7rem;
    padding-right: 0.2rem;
    border-bottom: 1px solid #f4f4f4;
    cursor: pointer;

    &.is-main {
      height: $mainItemHeight;
      background-color: #fff;
      cursor: auto;
      .name {
        font-size: 1rem;
        font-weight: 700;
      }
    }

    .data {
        display: block;
    }

    .name {
        color: #333;
        font-size: 0.87rem;
        font-weight: 500;
    }

    .info {
        color: #777;
        font-weight: 400;
        font-size: 0.7rem;
    }

    &:hover {
        background-color: #f9f9f9;
    }

    .graphs {
        display: flex;
        .graph {
            opacity: 0.6;
            margin-left: $graphSpacing*3;

            &:hover {
              opacity: 1;
            }

            .graph-line {
                height: ($graphHeight)/10 - $graphSpacing;
                background-color: #e3e3e3;
                width: 20px;
                margin-bottom: $graphSpacing;
            }

            &.graph-author .graph-line.is-active { background-color: hsl(149, 32%, 54%); }
            &.graph-interpret .graph-line.is-active { background-color: hsl(222, 91%, 64%); }
            &.graph-composer .graph-line.is-active { background-color: hsl(284, 35%, 51%); }
        }
    }
}
</style>
